import { faStar } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { CasinoCategoryViewModel } from '../../util/gaming'
import { Swiper, SwiperSlide } from 'swiper/react'
import { FreeMode } from 'swiper/modules'

export const CasinoCategoryQuickLinks = ({
  casinoCategoriesViewModel,
}: {
  casinoCategoriesViewModel: CasinoCategoryViewModel[]
}) => {
  const categories = casinoCategoriesViewModel?.filter(
    (cat) => cat.type !== 'highlights' && cat.type !== 'recently-played',
  )

  const onQuickLinkClicked = (categoryId: number) => {
    const element = document.getElementById('casino-category-' + categoryId)
    const offsetTop = element.offsetTop - 8
    if (element) {
      window.scroll({ top: offsetTop, behavior: 'smooth' })
    }
  }

  return (
    <>
      {categories?.length > 0 && (
        <div className="casino-category-quick-links revative overflow-hidden px-2 md:px-4">
          <Swiper
            className="casino-category-quick-links-swiper"
            wrapperClass="flex space-x-2"
            modules={[FreeMode]}
            slidesPerView={'auto'}
            freeMode
          >
            {categories.map((cat) => (
              <SwiperSlide className="casino-category-quick-links-swiper-slider !w-auto " key={cat.id}>
                <div
                  className="casino-category-quick-link flex space-x-3 items-center px-4 h-10 rounded-full whitespace-nowrap transition-colors bg-gray-500 bg-opacity-10 hover:bg-opacity-20 cursor-pointer"
                  onClick={() => onQuickLinkClicked(cat.id)}
                >
                  <span className="casino-category-quick-link-icon text-primary">
                    {cat.type === 'popular' && <FontAwesomeIcon icon={faStar} />}
                    {cat.type === 'custom' && cat.icon && <FontAwesomeIcon icon={['far', cat.icon as any]} />}
                  </span>
                  <span className="casino-category-quick-link-name text-xs font-semibold">{cat.name}</span>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}
    </>
  )
}
